import * as React from 'react';
import { SVGProps } from 'react';

const IconRoubleSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.04 6.874h-1.367v4.412h1.35c1.44 0 2.406-.76 2.406-2.215 0-1.453-.967-2.197-2.39-2.197z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm6-13c0 2.857-2.152 4.286-4.571 4.286h-1.756v1.571h4.613v1.429h-4.613v2.857h-2.53v-2.857H7v-1.429h2.143v-1.571H7v-2h2.143V4.857h4.286C15.797 4.857 18 6.143 18 9z"
    />
  </svg>
);
export default IconRoubleSizeM;
